import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getPerformance } from "firebase/performance";
import { getAnalytics, Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
// Guard client-only services for SSR/build — Firebase client SDK services
// crash during Next.js static generation when there's no browser environment.
const isBrowser = typeof window !== "undefined";

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
// Guard client-only services — functions & storage crash during Next.js
// static generation because their SDK providers aren't registered server-side.
const functions = isBrowser
  ? getFunctions(firebaseApp)
  : (null as unknown as ReturnType<typeof getFunctions>);
const storage = isBrowser
  ? getStorage(firebaseApp)
  : (null as unknown as ReturnType<typeof getStorage>);
let analytics: Analytics | undefined;
let performance;

if (
  process.env.NEXT_PUBLIC_ENVIRONMENT == "development"
) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  if (storage) connectStorageEmulator(storage, "127.0.0.1", 9199);
  if (functions) connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

if (process.env.NEXT_PUBLIC_ENVIRONMENT !== "test" && process.env.NEXT_PUBLIC_ENVIRONMENT !== "development") {
  if (isBrowser && firebaseApp.name) {
    performance = getPerformance(firebaseApp);
    analytics = getAnalytics(firebaseApp);
  }
}

export {
  firebaseApp as app,
  db,
  auth,
  functions,
  firebaseConfig,
  storage,
  performance,
  analytics,
};
